/**
 * init
 */
export const toggleInitMobile = () => {
  search.style.display = 'none'
  gsap.set(search, {
    y: '100%',
  })
  gsap.set(menuMobile, {
    opacity: '0',
  })
}
export const toggleInitPc = () => {
  search.style.display = 'block'
  gsap.set(search, {
    y: '0',
  })
  gsap.set(subMenu, {
    x: '-100%',
  })
}

/**
 * mobile
 * search
 */
const searchBg = document.querySelector('.search-bg')
const search = document.querySelector('.search')
const tlSearch = gsap.timeline()
let isAnimateSearch = false
const openSearch = () => {
  searchBg.style.display = 'block'
  search.classList.add('open')
  search.style.display = 'block'
  tlSearch.to(search, {
    duration: 0.8,
    ease: 'expo.out',
    y: 0,
    onComplete: () => {
      isAnimateSearch = true
    },
  })
}
const closeSearch = () => {
  searchBg.style.display = 'none'
  search.classList.remove('open')
  tlSearch.to(search, {
    duration: 0.8,
    ease: 'expo.out',
    y: '100%',
    onComplete: () => {
      isAnimateSearch = false
      search.style.display = 'none'
    },
  })
}
export const toggleSearch = () => {
  if (!search.classList.contains('open')) {
    if (!isAnimateSearch) {
      openSearch()
    }
  } else {
    if (isAnimateSearch) {
      closeSearch()
    }
  }
}

/**
 * mobile
 * search
 * page transitionのとき初期化
 */
export const closeTransitionSearch = () => {
  search.classList.remove('open')
  isAnimateSearch = false
  search.style.display = 'none'
  gsap.set(search, {
    y: '100%',
  })
}

/**
 * mobile
 * header menu
 */
const menuMobile = document.querySelector('.menu-mobile')
const tlMenuMobile = gsap.timeline()
let isAnimateMenuMobile = false
const openMenuMobile = () => {
  menuMobile.classList.add('open')
  menuMobile.style.display = 'block'
  tlMenuMobile.to(menuMobile, {
    onStart: () => {
      document.querySelector('.header-button_text').innerText = 'CLOSE'
    },
    duration: 0.8,
    ease: 'expo.out',
    opacity: 1,
    onComplete: () => {
      isAnimateMenuMobile = true
    },
  })
}
const closeMenuMobile = () => {
  menuMobile.classList.remove('open')
  tlMenuMobile.to(menuMobile, {
    onStart: () => {
      document.querySelector('.header-button_text').innerText = 'MENU'
    },
    duration: 0.8,
    ease: 'expo.out',
    opacity: '0',
    onComplete: () => {
      isAnimateMenuMobile = false
      menuMobile.style.display = 'none'
    },
  })
}
export const toggleMenuMobile = () => {
  if (!menuMobile.classList.contains('open')) {
    if (!isAnimateMenuMobile) {
      openMenuMobile()
    }
  } else {
    if (isAnimateMenuMobile) {
      closeMenuMobile()
    }
  }
}

/**
 * mobile
 * header menu
 * page transitionのとき初期化
 */
export const closeTransitionMenuMobile = () => {
  menuMobile.classList.remove('open')
  isAnimateMenuMobile = false
  menuMobile.style.display = 'none'
  document.querySelector('.header-button_text').innerText = 'MENU'
  gsap.set(menuMobile, {
    opacity: '0',
  })
}

/**
 * pc
 * sub menu
 * @param e element
 */
const subMenu = document.querySelector('.subMenu')
const subMenuLists = document.querySelectorAll('.subMenu-list')
const tlSubMenu = gsap.timeline()
const tlSubMenuList = gsap.timeline()
let isAnimateSubMenu = false
const openSubMenu = (subMenuList) => {
  subMenu.classList.add('open')
  subMenu.style.display = 'block'
  tlSubMenu
    .to(subMenu, {
      duration: 0.5,
      ease: 'expo.out',
      x: 0,
    })
    .to(
      subMenuList,
      {
        duration: 0.4,
        ease: 'expo.out',
        autoAlpha: 1,
        onComplete: () => {
          isAnimateSubMenu = true
        },
      },
      0.2
    )
}
const closeSubMenu = () => {
  subMenu.classList.remove('open')
  tlSubMenu
    .to(subMenuLists, {
      duration: 0.4,
      ease: 'expo.out',
      autoAlpha: 0,
    })
    .to(subMenu, {
      duration: 0.4,
      ease: 'expo.out',
      x: '-100%',
      onComplete: () => {
        isAnimateSubMenu = false
        subMenuLists.forEach((subMenuList) => {
          subMenuList.style.display = 'none'
        })
        subMenu.style.display = 'none'
      },
    })
}
const changeSubMenuList = (subMenuList) => {
  tlSubMenuList
    .to(subMenuLists, {
      duration: 0.4,
      ease: 'expo.out',
      autoAlpha: 0,
    })
    .to(subMenuList, {
      duration: 0.4,
      ease: 'expo.out',
      autoAlpha: 1,
    })
}
export const openSubMenuPc = (e) => {
  const target = e.currentTarget
  const dataTarget = target.dataset.menu
  if (!subMenu.classList.contains('open')) {
    if (!isAnimateSubMenu) {
      subMenuLists.forEach((subMenuList) => {
        const subMenuListData = subMenuList.dataset.menu
        if (dataTarget === subMenuListData) {
          subMenuList.style.display = 'flex'
          openSubMenu(subMenuList)
        }
      })
    }
  } else {
    if (isAnimateSubMenu) {
      subMenuLists.forEach((subMenuList) => {
        const subMenuListData = subMenuList.dataset.menu
        if (dataTarget === subMenuListData) {
          subMenuList.style.display = 'flex'
          changeSubMenuList(subMenuList)
        }
      })
    }
  }
}
export const closeSubMenuPc = () => {
  if (isAnimateSubMenu) {
    closeSubMenu()
  }
}

/**
 * pc
 * sub menu
 * page transitionのとき初期化
 */
export const closeTransitionSubMenuPc = () => {
  subMenu.classList.remove('open')
  isAnimateSubMenu = false
  subMenu.style.display = 'none'
  subMenuLists.forEach((subMenuList) => {
    subMenuList.style.display = 'none'
  })
  gsap.set(subMenu, {
    x: '-100%',
  })
  gsap.set(subMenuLists, {
    autoAlpha: 0,
  })
}
